<template>
    <div>
        <app-sub-title text="Gestión de permisos" />
        <div class="w-100">
            <div class="d-flex">
                <div class="w-25 pr-1">
                    <app-form-select-input 
                        label="Perfil" 
                        :options="profiles"
                        v-model="profile"
                        :is-object="true"
                        @change="loadProfileMenus"
                    />
                </div>
                <div class="w-25 pl-1">
                    <app-form-select-input v-if="profile && profile.slug === 'administrativo'"
                        label="Cargo" 
                        :options="positions"
                        v-model="positionId"
                        @change="loadPositionMenuOptionsByPosition"
                    />
                </div>
            </div>        
        </div>
        
        <app-position-menu-filters v-if="(profile && profile.slug == 'administrativo') && positionId"
            @filter="onFilterPositions"
            :menus="menus"
        />
        <app-profile-menu-filters v-if="(profile && profile.slug != 'administrativo')"
            @filter="onFilterProfiles"
            :menus="menus"
        />
        <div class="d-flex justify-content-between">
            <div>
                <app-sub-title text="Menús asociados"/>
            </div>
            <div>
                <b-button v-if="(profile && profile.slug != 'administrativo')" @click="addMenuToProfile" variant="primary"><i class="fa fa-plus"></i> Agregar menú al perfil</b-button>
                <b-button v-if="(profile && profile.slug == 'administrativo') && positionId" @click="addMenuToPosition" variant="primary"><i class="fa fa-plus"></i> Agregar menú al cargo</b-button>
            </div>
        </div> 
        <app-list-menu-options-assigned v-if="data"
            :data="data"
            :on-change-page="changePage"
            @delete-association="startDeleteAssociation"
            @sort="onSort"
            
        />
        <!-- @sort="onSortProfile" -->

        <!-- Inicio pop up's -->
            <app-pop-up title="Agregar menú al perfil" id="add-menu-profile" size="large" v-if="profile" :on-close="loadProfileMenuOptionsByProfile">
                <div class="body" slot="body">
                    <app-profile-menu-form
                        :the-profile-id="profile.id"
                        :menus="menus"
                    />
                </div>
            </app-pop-up>

            <app-pop-up title="Agregar menú al cargo" id="add-menu-position" size="large" v-if="positionId" :on-close="loadPositionMenuOptionsByPosition">
                <div class="body" slot="body">
                    <app-position-menu-form
                        :the-position-id="positionId"
                        :menus="menus"
                    />  
                </div>
            </app-pop-up>

            <app-pop-up title="Confirmación" id="remove-menu">
            <div slot="body"><h2>¿Esta seguro que desea desasignar este menu?</h2></div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteAssociation()"><i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar desasignación</button>
            </div>
        </app-pop-up>
        <!-- Fin pop up's -->
    </div>
</template>

<script>
import permissionManagerRepository from '../../../repositories/permissionManager.repository.js';
import ListMenuOptionsAssigned from './ListMenuOptionsAssigned/ListMenuOptionsAssigned.vue';
import PositionMenuForm from './PositionMenuForm/PositionMenuForm.vue';
import ProfileMenuForm from './ProfileMenuForm/ProfileMenuForm.vue';
import PositionMenuFilters from './PositionMenuFilters/PositionMenuFilters.vue';
import ProfileMenuFilters from './ProfileMenuFilters/ProfileMenuFilters.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        appListMenuOptionsAssigned: ListMenuOptionsAssigned,
        appPositionMenuForm: PositionMenuForm,
        appProfileMenuForm: ProfileMenuForm,
        appPositionMenuFilters: PositionMenuFilters,
        appProfileMenuFilters: ProfileMenuFilters
    },
    data(){
        return {
            profile: '',
            positionId: '',
            profileMenuOptions: '',
            positionMenuOptions: '',
            filtersProfileMenuOptions: null,
            filtersPositionMenuOptions: null,
            page: 1,
            data: {},
            menuSelect: '',
            menus: [],
            // sort: {
            //     sortBy: 'name',
            //     sortDir: 'asc'
            // }
        }
    },
    computed: {
        ...mapGetters(['positions', 'profiles'])
    },
    methods: {
        loadProfileMenus(){
            if(!!this.profile && this.profile.slug != 'administrativo'){
                this.loadProfileMenuOptionsByProfile();
            }else{
                this.data = {};
            }
        },
        loadProfileMenuOptionsByProfile(){
            const pmr = {...permissionManagerRepository};
            const filters = {...this.filtersProfileMenuOptions, profile: this.profile.id };//, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir };
            pmr.getProfileMenuOptions(filters, this.page)
            .then(data => this.data = data)
            .catch(error => toastr.error('Ocurrió un error al cargar los menus de opción del perfil'));
        },
        loadPositionMenuOptionsByPosition(){
            const pmr = {...permissionManagerRepository};
            const filters = {...this.filtersPositionMenuOptions, position: this.positionId };//, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir};
            pmr.getPositionMenuOptions(filters, this.page)
            .then(data => this.data = data)
            .catch(error => toastr.error('Ocurrió un error al cargar los menus de opción de los cargos'));
        },
        onFilterPositions(filters){
            this.filtersPositionMenuOptions = filters;
            this.page = 1;
            this.loadPositionMenuOptionsByPosition();
        },
        onFilterProfiles(filters){
            this.filtersProfileMenuOptions = filters;
            this.page = 1;
            this.loadProfileMenuOptionsByProfile();
        },
        changePage(page){
            this.page = page;
            if((this.profile && this.profile.slug == 'administrativo') && this.positionId){
                this.loadPositionMenuOptionsByPosition();
            }else{
                this.loadProfileMenuOptionsByProfile();
            }
        },
        addMenuToProfile(){
            this.$bus.$emit('add-menu-profile.open');
        },
        addMenuToPosition(){
            this.$bus.$emit('add-menu-position.open');
        },
        startDeleteAssociation(menu){
            this.menuSelect = menu;
            this.$bus.$emit('remove-menu.open');
        },
        deleteAssociation(){      
            const pmr = {...permissionManagerRepository};
            if(!!this.menuSelect.position_id){
                pmr.deletePositionMenuOption(this.menuSelect.id)
                .then(data => {
                    if(data.status){
                        toastr.success(data.msg);
                        this.loadPositionMenuOptionsByPosition();
                        this.$bus.$emit('remove-menu.close');
                    }else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => toastr.error('Error al eliminar asociación con menú'));
            }else{
                pmr.deleteProfileMenuOption(this.menuSelect.id)
                .then(data => {
                    if(data.status){
                        toastr.success(data.msg);
                        this.loadProfileMenuOptionsByProfile();
                        this.$bus.$emit('remove-menu.close');
                    }else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => toastr.error('Error al eliminar asociación con menú'));
            }
        },
        loadMenus(){
            const pmr = {...permissionManagerRepository};
            pmr.getAllMenus()
            .then(data => this.menus = data)
            .catch(error => toastr.error('Error al cargar los menús'));
        },
        onSort(ctx) {
            // this.sort.sortBy = ctx.sortBy;
            // this.sort.sortDir = ctx.sortDir;
            if((this.profile && this.profile.slug == 'administrativo') && this.positionId){
                this.loadPositionMenuOptionsByPosition();
            }else{
                this.loadProfileMenuOptionsByProfile();
            }
            
        }
         
    },
    created(){
        this.load('profiles');
        // this.loadPositions();
        this.loadMenus();

        this.load('positions');
    }
}
</script>
